/* eslint-disable react/no-danger */
import React from "react";
import { useTranslations } from "next-intl";
import { TourSummary } from "@/types/dto/pdp/pdp-tour-summary";
import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import ColletteReadMoreToggle from "@/components/common-controls/collette-read-more-toggle";
import InclusionsFeaturedExperiences from "./inclusions-featured-experiences";

interface OverviewDetailsProps {
  tourSummaryData: TourSummary;
}

const OverviewDetails = ({ tourSummaryData }: OverviewDetailsProps) => {
  const t = useTranslations("PDP");
  const isBelowMd = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <Box
      data-testid="overview-details-container"
      className={isBelowMd ? "fluid-box" : ""}
      sx={{
        flex: { xs: "1 1 100%", md: "0 0 65%" },
        bgcolor: "background.warm_strong",
        px: { xs: "2.4rem", sm: "3.2rem", md: "4rem" },
        py: { xs: "2.4rem", sm: "4rem", md: "4rem" },
        position: "relative",
        "&::before": {
          content: "\"\"",
          position: "absolute",
          top: 0,
          bottom: 0,
          right: "100%",
          width: "100vw",
          bgcolor: "background.warm_strong"
        }
      }}
    >
      <Box className="destination-page-container">
      <Stack spacing={2} mb={{ xs: 0, md: 3 }}>
        <Typography
          data-testid="tour-overview-heading"
          variant="h3"
          color="text.primary"
          sx={{ fontSize: "2.8rem", fontWeight: 600, lineHeight: 1.3 }}
        >
          {t("Tour Overview")}
        </Typography>
        <ColletteReadMoreToggle 
          description={tourSummaryData.summary}
          linesShown={4}
          testId="tour-overview-summary"
          textSx={{ lineHeight: 1.6, fontSize: "1.6rem", fontWeight: 400 }}
        />
      </Stack>

      <InclusionsFeaturedExperiences
        totalMeals={tourSummaryData.totalMeals}
        totalBreakfasts={tourSummaryData.totalBreakfasts}
        totalLunches={tourSummaryData.totalLunches}
        totalDinners={tourSummaryData.totalDinners}
        accommodationCount={tourSummaryData.accommodationCount}
        cultural={tourSummaryData.cultural}
        culinary={tourSummaryData.culinary}
        highlights={tourSummaryData.highlights}
        mustSee={tourSummaryData.mustSee}
        customSx={{ display: { xs: "none", md: "flex" } }}
        headingTestId="overview-inclusions-heading"
      />        
      </Box>
    </Box>
  );
};

export default OverviewDetails;
